<template>
  <div :class="$style.container">
    <div :class="$style.heading">{{ heading }}</div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "PanelGroup",
  props: {
    heading: {
      type: String,
      default: undefined
    }
  }
};
</script>

<style module lang="scss">
@import "./PanelGroup.scss";
</style>
